import { fabric } from 'fabric';
import _ from 'lodash';

export type PickDateIndicatorOptions = {
  canvas: fabric.Canvas;
  config: any;
  action: string;
};

// eslint-disable-next-line import/no-mutable-exports
let PickDateIndicator: any;

(function () {
  const STROKE = {
    strokeWidth: 1,
    selectable: false,
    hasBorders: false,
    stroke: '#F3A774',
    originX: 'center',
    originY: 'center',
  };

  const STROKE_BOOKMARK = {
    strokeWidth: 1,
    selectable: false,
    hasBorders: false,
    stroke: '#66D1A4',
    strokeDashArray: [5, 5],
    originX: 'center',
    originY: 'center',
  };

  PickDateIndicator = function ({ canvas, config, action }: PickDateIndicatorOptions) {
    this.type = 'PickDateIndicator';
    this.canvas = canvas;
    this.config = config;
    this.isVisible = true;
    this.x = -50;
    this.squareSize = 18.9; // config.majorDivSize of speed 25 / 5 grid;
    this.paddingText = 10;
    this.action = action;
    this.isBookmark = action === 'BOOKMARK';
  };

  PickDateIndicator.prototype.draw = function () {
    if (this.isBookmark) {
      this.line = new fabric.Line([this.x, 1, this.x, this.config.height], STROKE_BOOKMARK);
      this.line.id = 'pdi';
      this.canvas.add(this.line);
    } else {
      this.line = new fabric.Line([this.x, 1, this.x, this.config.height], STROKE);
      this.line.id = 'pdi';
      this.canvas.add(this.line);
      this.text = new fabric.Text(_.capitalize(this.action), {
        fontFamily: 'Lato, Arial, Helvetica, sans-serif',
        fontSize: 12,
        fontWeight: 700,
        fill: 'white',
        selectable: false,
        hasBorders: false,
        hoverCursor: 'arrow',
        originX: 'center',
        originY: 'center',
      });
      this.rect = new fabric.Rect({
        width: this.text.width + this.paddingText,
        height: this.squareSize,
        stroke: '#F3A774',
        fill: '#F3A774',
        rx: 3,
        ry: 3,
        selectable: false,
        hasBorders: false,
        hoverCursor: 'arrow',
        originX: 'center',
        originY: 'center',
      });
      this.rectWithText = new fabric.Group([this.rect, this.text], {
        left: this.x - (this.text.width + this.paddingText) / 2,
        top: 1,
        selectable: false,
        hoverCursor: 'arrow',
      });
      this.canvas.add(this.rectWithText);
      this.canvas.bringToFront(this.rectWithText);
    }
    this.render();
  };

  PickDateIndicator.prototype.update = function ({
    point,
    visible,
    action,
  }: {
    point?: { x: number };
    visible?: boolean;
    action?: string;
  }) {
    if (action) {
      this.action = action;
      this.isBookmark = action === 'BOOKMARK';
      if (!this.isBookmark) {
        this.text.set({ text: _.capitalize(this.action) });
        this.rect.set({ width: this.text.width + this.paddingText });
      }
    }
    if (!_.isNil(visible)) {
      this.line.set({ visible });
      if (!this.isBookmark) {
        this.rectWithText.set({ visible });
      }
    }
    if (point) {
      this.x = point.x;
      this.line.set({ x1: this.x, x2: this.x });
      if (!this.isBookmark) {
        this.rectWithText.set({
          left: this.x - (this.text.width + this.paddingText) / 2,
        });
        this.canvas.bringToFront(this.rectWithText);
      }
    }
    this.line.setCoords();
    if (!this.isBookmark) {
      this.rectWithText.setCoords();
    }
    this.render();
  };

  PickDateIndicator.prototype.render = function () {
    this.canvas.renderAll();
  };

  PickDateIndicator.prototype.delete = function () {
    this.canvas.remove(this.line);
    this.canvas.remove(this.rectWithText);
    this.text = null;
    this.rect = null;
    this.rectWithText = null;
    this.line = null;
    this.render();
  };

  PickDateIndicator.prototype.getJSONObject = function () {
    return {
      type: this.type,
      position: this.xr,
    };
  };
})();

export { PickDateIndicator };
export default { PickDateIndicator };
